import { Component, Input } from '@angular/core';
import { ActivityMetricsV2FixedPointProvenanceRow } from '../../../../shared/models/activity-metrics-v2.model';

@Component({
  selector: 'app-agent-performance-activity-metrics-fixed-point-provenance-widget',
  templateUrl: './agent-performance-activity-metrics-fixed-point-provenance-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-fixed-point-provenance-widget.component.scss']
})
export class AgentPerformanceActivityMetricsFixedPointProvenanceWidgetComponent {
  @Input() rows: ActivityMetricsV2FixedPointProvenanceRow[] = [];
  @Input() widget_title = 'Fixed Point Provenance';

  formatFallbackStepLabel(stepKey: string | null | undefined): string {
    if (!stepKey) {
      return '-';
    }

    if (stepKey === 'primary') {
      return 'Primary';
    }

    if (stepKey === 'missing') {
      return 'Missing';
    }

    return stepKey
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (character) => character.toUpperCase());
  }
}
